import {buildUniqueId} from '../utils/build-unique-id';

import type {LimitsMap} from './typedef';
import type {InputSelector} from '../../../../services/typedef';
import type {ChangesInfo} from 'src/openapi/admin/models/ChangesInfo';
import type {LimitList} from 'src/openapi/admin/models/LimitList';
import type {OverageSettings} from 'src/openapi/admin/models/OverageSettings';
import type {PricingModel} from 'src/openapi/admin/models/PricingModel';
import type {AppState} from 'src/store/typedef';


type LimitProps = {
    accountId: number,
    pricingModel: PricingModel,
};

export const getLimitsData = (state: AppState, {accountId, pricingModel}: LimitProps): LimitList | null => {
    return state.apiv2.limits.data?.[pricingModel as PricingModel]?.[accountId] || null;
};

export const getChangesInfo = (state: AppState, props: LimitProps): ChangesInfo | null => {
    return getLimitsData(state, props)?.changesInfo || null;
};

export const makeGetLimitsWithIds = (state: AppState, params: LimitProps): LimitsMap => {
    const limitsData = getLimitsData(state, params);

    if (limitsData) {
        return limitsData.limits.reduce((withIds, limit) => {
            withIds[buildUniqueId(limit)] = limit;
            return withIds;
        }, {} as LimitsMap);
    }
    return {};
};

export const getOverageStatus: InputSelector<{accountId: number}, OverageSettings | null> = (state, {accountId}) =>
    state.apiv2.limits.overageStatus[accountId];

